import CSS from 'csstype';

import { isLanguageOversized } from '~/src/locales/common';

export const borderRadius = {
  small: '3px',
  base: '4px',
  large: '5px',
  extraLarge: '6px',
};

export const getOversizedLanguageUIFriendlyStyle = (language: string): CSS.Properties => {
  if (isLanguageOversized(language)) {
    return {
      wordBreak: 'keep-all',
      overflowWrap: 'break-word',
      whiteSpace: 'normal',
    };
  }
  return {};
};
